import intlMessagesEN from './i18n/localization/en.json';
import intlMessagesVi from './i18n/localization/vi.json';

export default {
  name: 'Public',
  dir: 'Public',
  pathRoot: '',
  routes: [
    {
      url: 'identity',
      component: 'Page/Identity',
      meta: {
        authRoute: true,
      },
      layout: 'BlankLayout',
      props: {
        title: 'Trang chủ | Smart Event',
        titleI18n: 'Public:registerEvent',
        headerStyle: 'fill',
        exact: true,
      },
    },
    {
      url: 'thiep-moi/:inviteCode',
      component: 'Page/Dashboard',
      meta: {
        authRoute: true,
      },
      layout: 'BlankLayout',
      props: {
        title: 'Thiệp điện tử | Smart Event',
        titleI18n: 'Public:inviteCardTitle',
        headerStyle: 'fill',
        exact: true,
      },
    },
    {
      url: 'su-kien/dang-ky/:eventId',
      component: 'Page/Register',
      meta: {
        authRoute: true,
      },
      layout: 'BlankLayout',
      props: {
        title: 'Trang chủ | Smart Event',
        titleI18n: 'Public:registerEvent',
        headerStyle: 'fill',
        exact: true,
      },
    },
    {
      url: 'thu-vien-anh/:eventId',
      component: 'Page/Gallery',
      meta: {
        authRoute: true,
      },
      layout: 'BlankLayout',
      props: {
        title: 'Trang chủ | Smart Event',
        titleI18n: 'Public:gallery',
        headerStyle: 'fill',
        exact: true,
      },
    },
    {
      url: 'ket-noi-giao-thuong/:eventId',
      component: 'Page/SaveContact',
      meta: {
        authRoute: true,
      },
      layout: 'BlankLayout',
      props: {
        title: 'Trang chủ | Smart Event',
        titleI18n: 'Public:saveContact',
        headerStyle: 'fill',
        exact: true,
      },
    },
    {
      url: ':wedding/thiep-moi/:inviteCode',
      component: 'Page/DashboardWedding',
      meta: {
        authRoute: true,
      },
      layout: 'BlankLayout',
      props: {
        title: 'Thiệp mời đám cưới | Smart Event',
        titleI18n: 'Public:inviteCardTitle',
        headerStyle: 'fill',
        exact: true,
      },
    },
    {
      url: ':wedding/wedding',
      component: 'Page/MainDashboardWedding',
      meta: {
        authRoute: true,
      },
      layout: 'BlankLayout',
      props: {
        title: 'Thiệp mời đám cưới | Smart Event',
        titleI18n: 'Public:inviteCardTitle',
        headerStyle: 'fill',
        exact: true,
      },
    },
    {
      url: 'gui-loi-chuc-phuc/:id',
      component: 'Page/DashboardWeddingToWishes',
      meta: {
        authRoute: true,
      },
      layout: 'BlankLayout',
      props: {
        title: 'Gửi lời chúc phúc| Smart Event',
        titleI18n: 'Public:send_wishes',
        headerStyle: 'fill',
        exact: true,
      },      
    },
     {
      url: 'doi-diem/:inviteCode',
      component: 'Page/ScanRewardRedemptionPage',
      meta: {
        authRoute: true,
      },
      layout: 'BlankLayout',
      props: {
        title: 'Đổi quà| Smart Event',
        titleI18n: 'Public:scanRewardRedemptionPage',
        headerStyle: 'fill',
        exact: true,
      },      
    },
    {
      url: 'quay-tich-diem/:inviteCode',
      component: 'Page/ScanRewardPoint',
      meta: {
        authRoute: true,
      },
      layout: 'BlankLayout',
      props: {
        title: 'Tích điểm| Smart Event',
        titleI18n: 'Public:scanRewardPoint',
        headerStyle: 'fill',
        exact: true,
      },      
    },
  ],
  lang: { vi: intlMessagesVi, en: intlMessagesEN },
  isAuthenticate: 'Any',
};
